import React, {useEffect, useState} from 'react';
import { Field } from 'react-final-form';
import RadioButton from './RadioBig';
import Grid from "@material-ui/core/Grid";
import { Trans } from "../utils/i18n";

const PartnerSelect = React.memo(function ({ partner_id, appointmentGroup, form }) {
        // const orderEntryDispatch = useOrderEntryDispatch();
        // const { products } = useOrderEntryState();
        const [partners, setParners] = useState(null);

        useEffect(() => {
            if(!appointmentGroup) {
                return;
            }
            fetch(`/appointment/partners?appointmentGroup=${appointmentGroup}`)
                .then(response => response.json())
                .then(response => {
                    if(!response.success) {
                        throw 'error';
                    }
                    setParners(response.partners);
                })

        }, [appointmentGroup]);

        useEffect(() => {
            if (partner_id) {
                form.change('day', undefined);
                form.change('timeslot', undefined);
            }
        }, [partner_id]);

        useEffect(() => {
            if (partners && partners.length === 1) {
                form.change('partner_id', String(partners[0].id));
            }
        }, [partners]);

        if (!partners) {
            return <div><Trans i18nKey="productSelect.loading">Loading</Trans></div>;
        }

        if(partners.length === 0) {
            return <div></div>
        }

        //const currentProduct = products && products.find(item => String(item.id) === product);

        return (
            <div>
                <Grid container spacing={3}>
                    {
                        partners
                            .map((item) =>
                                <Grid item xs={12} sm={3} key={item.id}>
                                    <Field
                                        name={'partner_id'}
                                        type={'radio'}
                                        value={String(item.id)}
                                        //placeholder={field.placeholder}
                                        component={RadioButton}
                                        validate={value => (value ? undefined : <Trans i18nKey="productSelect.required">Required</Trans>)}
                                        field={{
                                            label: item.name,
                                            titel: item.city,
                                            description: [
                                                item.name,
                                                item.street,
                                                item.street2,
                                                `${item.zip} ${item.city}`,
                                                item.country?.name,
                                            ].filter(item => item).join('\n'),
                                            image: item.image,
                                            descriptionSize: 'small',
                                        }}
                                    />
                                </Grid>,
                            )
                    }
                </Grid>
            </div>
        );
    },
    function areEqual(prevProps, nextProps) {
        return JSON.stringify(prevProps) === JSON.stringify(nextProps);
    });

export default PartnerSelect;
